import * as Sentry from '@sentry/browser'
import axios, { AxiosResponse } from 'axios'
import { Store } from 'redux'
import { ACCESS_TOKEN, CLIENT, UID } from '../commons/Const'
import { getParams, getStorage, removeStorage } from '../commons/utils'

export const axiosSetting = (store: Store): void => {
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
  axios.defaults.baseURL = process.env.CLIENT_BASE_PATH

  axios.interceptors.request.use(config => {
    config.params = {
      ...config.params,
      ...getParams()
    }

    const token = getStorage(ACCESS_TOKEN) || getParams().token
    if (present(token)) {
      config.headers['access-token'] = token
    }
    const uid = getStorage(UID)
    const client = getStorage(CLIENT)
    if (present(uid) && present(client)) {
      config.headers.uid = uid
      config.headers.client = client
    }
    return config
  })

  const onResponseSuccess = (response: AxiosResponse<any>) => response
  const onResponseFail = (error: any) => {
    if (error.message === 'Network Error') {
      error.response = {
        data: {
          code: 'error.network',
          message: '通信エラーが発生しました。お手数をおかけしますが、ブラウザ画面の再読み込みをお願いいたします。'
        }
      }
      return Promise.reject(error)
    }
    const status = error.status || error.response.status
    if (status === 401) {
      removeStorage(ACCESS_TOKEN)
      removeStorage(UID)
      removeStorage(CLIENT)
    }
    if (status > 500) {
      error.response = {
        data: {
          message: error.message
        }
      }
      Sentry.withScope(scope => {
        scope.setExtra('currentState', store.getState())
        Sentry.captureException(error)
      })
    }
    return Promise.reject(error)
  }
  axios.interceptors.response.use(onResponseSuccess, onResponseFail)
}

const present = (input: string | null): boolean => {
  return input != null && input.length > 0
}
